import { useNavigate } from 'react-router-dom';
import LandingNav2 from '@/components/landing/LandingNav2';
import HeroSection2 from '@/components/landing/HeroSection2';
import TestimonialsSection from '@/components/landing/TestimonialsSection';
import CoupleSection2 from '@/components/landing/CoupleSection2';
import SolutionSection2 from '@/components/landing/SolutionSection2';
import HowItWorks2 from '@/components/landing/HowItWorks2';
import PricingSection2 from '@/components/landing/PricingSection2';
import FAQSection from '@/components/landing/FAQSection';
import FinalCta2 from '@/components/landing/FinalCta2';
import Footer2 from '@/components/landing/Footer2';

export default function Landing2() {
  const navigate = useNavigate();
  const goToApp = () => navigate('/auth/register');

  return (
    <div className="min-h-screen bg-white dark:bg-gray-950">
      <LandingNav2 onCta={goToApp} />
      <HeroSection2 onCta={goToApp} />
      <TestimonialsSection />
      <CoupleSection2 onCta={goToApp} />
      <SolutionSection2 />
      <HowItWorks2 />
      <PricingSection2 onCta={goToApp} />
      <FAQSection />
      <FinalCta2 onCta={goToApp} />
      <Footer2 />
      
      {/* Sticky CTA for mobile */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-white/90 dark:bg-gray-950/90 backdrop-blur-lg border-t border-gray-200 dark:border-gray-800 md:hidden z-40">
        <button onClick={goToApp} className="w-full btn-primary py-3">
          Empezar gratis — sin tarjeta
        </button>
      </div>
    </div>
  );
}
